export default __webpack_public_path__ + "static/media/whatsAppRealcase-en-mobile.4d7d2209.png";